export default "__VITE_ASSET__f28cdc93__"